<!-- 规则与声明 -->
<template>
    <div class="declarations">
        <div class="titleBOx">
               <h2 class="title">
                {{help.titel88}}
            </h2>
        </div>
        <div class="content"> 
            <p class="tip2">{{help.titel89}}</p>
            <h3 class="tip1">{{help.titel90}}</h3>
            <p class="tip2">{{help.titel91}}</p>
            <p class="tip2">{{help.titel92}}</p>
            <p class="tip2">{{help.titel93}}</p>

            <h3 class="tip1">{{help.titel94}}</h3>

            <p class="tip2">{{help.titel95}}</p>
            
            <h3 class="tip1">{{help.titel96}}</h3>

            <p class="tip2">{{help.titel97}}</p>

            <p class="tip2">{{help.titel98}}</p>

            <p class="tip2">{{help.titel99}}</p>

            <p class="tip2">{{help.titel100}}</p>

            <p class="tip2">{{help.name1}} </p>

            <h3 class="tip1">{{help.name2}}</h3>
            <p class="tip2">{{help.name3}}</p>
            <p class="tip2">{{help.name4}}</p>
            <p class="tip2">{{help.name5}}</p>
            <p class="tip2">{{help.name6}}</p>
            <p class="tip2">{{help.name7}}</p>
            <p class="tip2">{{help.name8}}</p>

            <h3 class="tip1">{{help.name9}}</h3>
            <p class="tip2">{{help.name10}}</p>
            <p class="tip2">{{help.name11}}</p>
            <h3 class="tip1">{{help.name12}}</h3>
            <p class="tip2">{{help.name13}}</p>
            <p class="tip2">{{help.name14}}</p>
            <p class="tip2">{{help.name15}}</p>

        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
        }
    },
    computed: {
        help() {
            return this.$t('help')
        }
    },
    methods:{
    },
    mounted(){

    }
}
</script>
<style scoped lang='scss'>
    .declarations{
        .titleBOx{
            border-bottom: 2px solid #f0f0f0;
            width: 100%;
            height: 60px;
            .title{
                line-height: 60px;
                margin-left: 30px;
                font-size: 24px;
                font-weight: 200;
                color: #e21;
            }
        }
        .content{
            padding: 30px 30px 50px;
            .tip1{
                padding: 10px 0px 20px;
                line-height: 30px;
                font-size: 18px;
                font-weight: 500;
            }
            .tip2{
                line-height: 32px;
                font-size: 14px;
                color: #666;
                text-indent: 2em;
                .tip3{
                    color: #ec2828;
                }
            }
        }
    }
</style>